import * as z from "zod";
import { literal } from "zod";
import { ConfirmContactSupport } from "../../agents/support-agents/confirm-contact-support";
import { ContentType } from "../../conversation";
import {
  AutoGeneratedFieldsSchema,
  BaseToolCallMessageSchema,
  WithoutId,
} from "../message-parser-utils";

const ContactSupportMessageSchema = BaseToolCallMessageSchema.extend({
  contentType: literal(ContentType.CONTACT_SUPPORT_UI),
  structuredContent: ConfirmContactSupport.optional(),
});
export const ContactSupportMessageDbParser = ContactSupportMessageSchema.merge(
  AutoGeneratedFieldsSchema,
);

export type ContactSupportMessageType = z.infer<
  typeof ContactSupportMessageDbParser
>;
export type ContactSupportMessageTypeWithoutId =
  WithoutId<ContactSupportMessageType>;
